/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, themeV2 } from '@insticator/insticator-ui';
import { hoverTransition } from '../../../../utils/styles/general';



/* ++++++++++ --------------- CARD TOGGLE : STYLES --------------- ++++++++++ */
export default {
    cardtoggle: {
        cursor: 'pointer',
        display: 'flex',
        height: pxToEm(100),
        marginBottom: pxToEm(24),
        paddingRight: pxToEm(24),
        extend: hoverTransition(),
        '&.isActive': {
            '&-true': {
                cursor: 'default'
            },
            '&-false': {
                '&:hover': {
                    '& .content': {
                        '& .value, .label': {
                            color: themeV2.color.primary.light
                        }
                    }
                }
            }
        },
        '&:last-child': {
            marginRight: 0
        },
        '& .selectedbar': {
            width: pxToEm(24),
            boxShadow: props => props.selected ? replacePXinStringWithEM(`inset 4px 0px 0px 0px ${themeV2.color.primary.main}`) : replacePXinStringWithEM('inset 1px 0px 0px 0px rgba(178, 193, 230, 0.3)'),
            height: props => !props.selected && pxToEm(24)
        },
        '& .content': {
            display: 'grid',
            '& .label': {
                color: props => props.selected ?  themeV2.color.primary.main : themeV2.color.base.gray.dark,
                // lineHeight: pxToEm(24),
                marginBottom: pxToEm(6),
                extend: hoverTransition()
            },
            '& .value': {
                color: props => props.selected ?  themeV2.color.primary.main : themeV2.color.base.gray.dark,
                fontSize: pxToEm(32),
                // lineHeight: pxToEm(40),
                // marginBottom: pxToEm(10),
                fontWeight: props => !props.selected && 300,
                // fontFamily: props => !props.selected && 'system-ui',
                extend: hoverTransition()
            },
            '& .compare': {
                display: 'flex',
                fontSize: pxToEm(12),
                fontWeight: '500',
                lineHeight: pxToEm(16),
                '& .percent': {
                    width: pxToEm(50),
                    height: pxToEm(24),
                    borderRadius: pxToEm(12),
                    fontWeight: '600',
                    textAlign: 'center',
                    // lineHeight: pxToEm(16),
                    paddingTop: pxToEm(3)
                },
                '& span': {
                    color: themeV2.color.base.gray.dark,
                    marginLeft: pxToEm(8),
                    paddingTop: pxToEm(3)
                }
            }
        }
    }
};
